import React$1 from 'react';

const Youtube = () => /*#__PURE__*/React$1.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40"
}, /*#__PURE__*/React$1.createElement("path", {
  fill: "#FF005F",
  fillRule: "evenodd",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20zm10-20l-15 9V11l15 9z"
}));

export default Youtube;
